const MODE = import.meta.env.VITE_MODE;

export default {
  API_URL: import.meta.env.VITE_SERVER_DOMAIN,
  STRIPE_KEY: import.meta.env.VITE_STRIPE_KEY,
  IS_DEVELOPMENT: MODE === 'development',
  IS_STAGING: MODE === 'staging',
  IS_PRODUCTION: MODE === 'production',
};
